import { render } from "./ReviewForm.vue?vue&type=template&id=c822ef42&scoped=true"
import script from "./ReviewForm.vue?vue&type=script&lang=js"
export * from "./ReviewForm.vue?vue&type=script&lang=js"

import "./ReviewForm.vue?vue&type=style&index=0&id=c822ef42&lang=scss"
import "./ReviewForm.vue?vue&type=style&index=1&id=c822ef42&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c822ef42"]])

export default __exports__